import React, { Component, Fragment } from 'react';

import About from '../About';
import VideoGrid from '../VideoGrid';
import VideoGridItem from '../VideoGrid/VideoGridItem';
import Contact from '../Contact';
import Banner from '../Banner';
import Events from '../Events';
import { Slider, SliderItem, SliderImage } from '../Slider';
import EventItem from '../Events/EventItem';
import ghHighlifeTributes from '../../images/sliders/gh-high-life-tributes.jpg';

import homepagewallpaper1 from '../../images/homepagebanner.jpg';
import mothersdaytribute from '../../images/mothersdaytribute.jpeg';
import homepagewallpaper2 from '../../images/christmaslinkup.jpg';
import homepagewallpaper3 from '../../images/ghanahighlife.jpg';
import homepagewallpaper2mobile from '../../images/christmaslinkup-mobile.jpg';
import jeff_image_1 from '../../images/jeffrey-pic.jpeg';
import ghanaescapes from '../../images/ghanaescapes2.jpg';

class Homepage extends Component {

    render() {
        return (
            <Fragment>
                {/*<SliderVideo youtubeId="mqwum4p60uQ"/>*/}
                <Slider>
                    <SliderItem
                        bodyContent={<h1>UK Host & Presenter</h1>}
                        image={homepagewallpaper1}
                        ctaButtonText="Find out more"
                        ctaButtonUrl="#about"
                    />
                    <SliderItem
                        bodyContent={<h1>UK Host & Presenter</h1>}
                        image={mothersdaytribute}
                        ctaButtonText="Buy Tickets"
                        ctaButtonUrl="https://shoobs.com/events/48120/ghana-highlife-tributes"
                    />
                </Slider>
                <About />
                <VideoGrid
                    title="Media"
                    subtitle="COMING SOON"
                >
                </VideoGrid>
                <Events>
                    <EventItem
                        location="99 High Holborn, London, WC1V 6LF"
                        title="GHANA HIGHLIFE TRIBUTES (Mothers Day Special)"
                        date="2020-03-22"
                        url="https://shoobs.com/events/48120/ghana-highlife-tributes"
                    />
                </Events>
                <Banner
                    image={ghanaescapes}
                    bodyContent={<div><h1>Ghana Escapes</h1><p>Ghana's Number One Holiday Package</p></div>}
                    ctaButtonUrl="http://www.ghanaescapes.com"
                    ctaButtonText="Ghana Escapes"
                />
                <Contact />
            </Fragment>
        )
    }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/Homepage/index.jsx